import { getAction } from "@/api/manage";
export default {
  data: function data() {
    return {
      cmsInfo: {},
      extraFilename: {}
    };
  },
  watch: {
    $route: function $route(to, from) {
      this.getCmsDetail();
    }
  },
  created: function created() {
    this.getCmsDetail();
  },
  methods: {
    getCmsDetail: function getCmsDetail() {
      var _this = this;
      getAction("/teaching/teachingCms/getCmsDetail?id=" + this.$route.query.id).then(function (res) {
        if (res.success) {
          _this.cmsInfo = res.result;
          _this.extraFilename = JSON.parse(_this.cmsInfo.extraFilename);
        }
      });
    }
  }
};